import { Component, Input, OnInit } from '@angular/core';
import { RewardService } from 'src/app/account/services/reward.service';

@Component({
  selector: 'app-barcode-qrcode',
  templateUrl: './barcode-qrcode.component.html',
  styleUrls: ['./barcode-qrcode.component.scss']
})
export class BarcodeQrcodeComponent implements OnInit {
  @Input() barCodeValue : any;
  @Input() qrCodeValue : any;
  @Input() isShowDesc : boolean = true;
  @Input() QrHeight: any;
  @Input() QrWidth: any;
  @Input() barCodeWidth: any;
  @Input() barCodeHeight: any;
  @Input() qrbarcodegap: any;
  @Input() showBothCodesInPopup: boolean = false;

  constructor(
    private rewardService: RewardService,
  ) {}

  ngOnInit(): void {
  }

  showQRDialog() {
    this.rewardService.qrDialog.next({
      isShow: true,
      qrCodeValue: this.qrCodeValue,
      barCodeValue: this.showBothCodesInPopup ? (this.barCodeValue || this.qrCodeValue) : undefined
    });
  }

  showBarCodeDialog() {
    this.rewardService.qrDialog.next({
      isShow: true,
      barCodeValue: this.barCodeValue,
      qrCodeValue: this.showBothCodesInPopup ? (this.qrCodeValue || this.barCodeValue) : undefined
    });
  }
}
